import { FC } from 'react';
import { StanModal } from '@/components/core-components/StanModal/StanModal';

interface DuplicatePaymentModalProps {
    isOpen: boolean;
    maskedEmail: string;
    trialDays: number;
    onConfirm: () => void;
    onGoToLogin: () => void;
}

/**
 * Modal shown when a payment method is already used by another account.
 * Gives user the option to continue with a new account or login to existing.
 */
export const DuplicatePaymentModal: FC<DuplicatePaymentModalProps> = ({
    isOpen,
    maskedEmail,
    trialDays,
    onConfirm,
    onGoToLogin,
}) => {
    const primaryActionLabel = trialDays > 0 ? `Yes, Start My ${trialDays}-Day Trial` : 'Yes, Start My Subscription';

    return (
        <StanModal
            id='duplicate-payment-modal'
            isOpen={isOpen}
            title='Are you sure you want to create another account?'
            primaryActionLabel={primaryActionLabel}
            secondaryActionLabel='No, login to Existing Account'
            hideCloseButton
            nonDismissible
            size='sm'
            onPrimaryAction={onConfirm}
            onSecondaryAction={onGoToLogin}
        >
            <p className='text-body-md text-gray text-center'>
                This card has already been used to register an account using this email &ldquo;{maskedEmail}&rdquo;
            </p>
        </StanModal>
    );
};
